import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, viewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogMenuComponent } from './dialog-menu/dialog-menu.component';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ButtonComponent } from '../../common/components/general/button/button.component';
import { ContentModel } from '../../common/models/content.model';
import { MenuAppLinks } from './menu.model';
import { DialogMenuData } from './dialog-menu/dialog-menu.model';
import { Location } from '@angular/common';


@Component({
  selector: 'nuc-menu',
  imports: [ButtonComponent],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnChanges, OnInit {
  @Output() menuAction = new EventEmitter<string>();
  @Input() pageContent: ContentModel[];
  @Input() menuAppLinks: MenuAppLinks;
  @Input() isExpandMoreOpen: boolean;

  isDialogOpen: boolean = false;
  private dialogRef: MatDialogRef<DialogMenuComponent>;

  constructor(private dialog: MatDialog, private overlayContainer: OverlayContainer, private location: Location) { }
  
  ngOnInit(): void {
    this.location.onUrlChange(() => {
      if (this.isDialogOpen) {
        this.dialogRef?.close();
      }
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['isExpandMoreOpen']){
      this.isExpandMoreOpen && this.dialogRef?.close();
    }
  }

  openDialog() {
    if(this.isDialogOpen){
      this.dialogRef.close();
      return;
    }
    this.isDialogOpen = true;
    const dialogMenuData = new DialogMenuData();
    dialogMenuData.appLinks = this.menuAppLinks;
    dialogMenuData.pageContent = this.pageContent;

    this.dialogRef = this.dialog.open(DialogMenuComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      panelClass: 'full-screen-dialog',
      data: dialogMenuData,
    });
    this.menuAction.emit('open');

    // Add custom class to cdk-overlay-container
    this.overlayContainer.getContainerElement().classList.add('menu-dialog-overlay');

    this.dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
      this.menuAction.emit('close');
      // Remove custom class from cdk-overlay-container
      this.overlayContainer.getContainerElement().classList.remove('menu-dialog-overlay');
    });
   
  }
}
